import { AnalyticsIcon } from "@/components/icons";
import { SideBarRouteOption } from "@/types";
import { FaMoneyCheck } from "react-icons/fa";
import { BiCog } from "react-icons/bi";
import { FaMoneyCheckDollar } from "react-icons/fa6";

const licencingApprovalOfficesRoutes: SideBarRouteOption[] = [
  {
    name: "Statistics",
    path: "/approvalofficesaccount",
    icon: AnalyticsIcon,
  },
  {
    name: "Analytics",
    path: "/approvalofficesaccount/analytics",
    icon: AnalyticsIcon,
  },

  {
    name: "Applications",
    path: "/approvalofficesaccount/applications",
    icon: FaMoneyCheckDollar,
    hasSubRoutes: true,
    routes: [
      {
        name: "All Applications",
        path: "/approvalofficesaccount/applications/allapplications",
        icon: FaMoneyCheck,
      },
      {
        name: "On Hold Applications",
        path: "/approvalofficesaccount/applications/onholdapplications",
        icon: FaMoneyCheck,
      },
      {
        name: "Approved Applications",
        path: "/approvalofficesaccount/applications/approved-applications",
        icon: FaMoneyCheck,
      },
      {
        name: "Applications Modifications",
        path: "/approvalofficesaccount/applications/applications-modification",
        icon: FaMoneyCheck,
      },
    ],
  },
  {
    name: "Rejected Reports",
    path: "/approvalofficesaccount/rejectedreports",
    icon: FaMoneyCheckDollar,
    hasSubRoutes: true,
    routes: [
      {
        name: "Renewal License",
        path: "/approvalofficesaccount/rejectedreports/licenserenew",
        icon: FaMoneyCheck,
      },
      {
        name: "Indexing",
        path: "/approvalofficesaccount/rejectedreports/indexing",
        icon: FaMoneyCheck,
      },
    ],
  },
  {
    name: "Financial Reports",
    path: "/approvalofficesaccount/Rejected Reports",
    icon: FaMoneyCheckDollar,
    hasSubRoutes: true,
    routes: [
      {
        name: "Student Indexing Under Graduate",
        path: "/approvalofficesaccount/test/test",
        icon: FaMoneyCheckDollar,
      },
      {
        name: "Student Indexing Under A-Level",
        path: "/approvalofficesaccount/test/test",
        icon: FaMoneyCheck,
      },
    ],
  },
  {
    name: "Settings",
    path: "/approvalofficesaccount/Manually Assign",
    icon: BiCog,
    hasSubRoutes: true,
    routes: [
      {
        name: "Manual Assign RegNo",
        path: "/approvalofficesaccount/modifications/ManualAssignRegNo",
        icon: BiCog,
      },
      {
        name: "Existing RegNo",
        path: "/approvalofficesaccount/modifications/ManualAssignExistingRegistration",
        icon: BiCog,
      },
      {
        name: "Assign Index",
        path: "/approvalofficesaccount/modifications/ManualAssignIndexing",
        icon: BiCog,
      },
      {
        name: "Existing Index",
        path: "/approvalofficesaccount/modifications/ManualAssignExistingIndex",
        icon: BiCog,
      },
    ],
  },
];

export default licencingApprovalOfficesRoutes;
